import { SelectionModel } from '@angular/cdk/collections';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { RequestStatuses, StatusEnum } from 'src/app/constants/status.enum';
import { RequestItemInDashboard } from 'src/app/models/dashboard';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { LoggingService } from 'src/app/services/logging.service';

@Component({
  selector: 'app-request-table-row',
  templateUrl: './request-table-row.component.html'
})
export class RequestTableRowComponent implements OnInit {
  @Input() request!: RequestItemInDashboard;
  @Input() selection!: SelectionModel<RequestItemInDashboard>;
  @Input() anyWorkgroup!: Boolean;
  @Input() workgroup: boolean = false;
  user: any;
  showAll: boolean = false;
  ShowAllDocsInOrg: string = "false";

  // translation holders
  translatedSentAction: string = "";
  translatedCompletedAction: string = "";
  translatedNextAction: string = "";
  translatedPreviousAction: string = "";
  translatedType: string = "";
  translatedCurrentUserAction: string = "";

  private get isRequestCompleted(): boolean {
    return this.request.status == StatusEnum.Completed;
  }
  private get isRequestExpired(): boolean {
    return this.request.status == StatusEnum.Expired;
  }
  /**
   * Toggles the row styling
   */
  public get displayAsInactive(): boolean {
    return this.isRequestExpired;
  }

  constructor(private router: Router,
    private authenticationService: AuthenticationService,
    private loggingService: LoggingService,
    private translateService: TranslateService) {
    this.authenticationService.currentUser.subscribe((data) => {
      this.user = data;
    });
  }

  ngOnInit(): void {
    this.ShowAllDocsInOrg = sessionStorage.getItem("ShowAllDocsInOrg") ?? "false";
    if (this.ShowAllDocsInOrg != undefined && this.ShowAllDocsInOrg != null && this.ShowAllDocsInOrg != "false") {
      this.showAll = true;
    } else {
      this.showAll = false;
    }
  }

  public clickOnRequest() {
    this.goToRequest(this.request.requestId, this.request.status, this.request.workflowId)
  }

  public get displayGoToRequestButton(): boolean {
    return this.request.actionRequired && (RequestStatuses.ThatAreActorPending as string[]).includes(this.request.status);
  }

  private goToRequest(requestId: string, status: string, workflowId: string | null = null) {
    if (status === "Processing" || status === "New" || status === "Active") {
      this.router.navigate(["/build/" + requestId + ""], { queryParams: { workflowId: workflowId } })
        .catch(error => {
          this.loggingService.logException(error);
        });
    } else {
      this.router.navigate(["/request/" + requestId + ""])
        .catch(error => {
          this.loggingService.logException(error);
        });
    }
  }

  //  Also displayed on the special button
  public goToSentRequest(requestId: string, status: string, workflowId: string | null = null) {
    if (this.displayGoToRequestButton && (status != "Processing" && status != "New" && status != "Active" && status != "Error")) {
      let url = this.router.serializeUrl(this.router.createUrlTree(["/view/" + requestId]));
      if (this.request.status === "PendingDownload") {
        url = this.router.serializeUrl(this.router.createUrlTree(["/download/" + requestId]));
      }
      window.open(url, '_blank');
    } else {
      this.goToRequest(requestId, status, workflowId)
    }
  }

  public getLastUpdated() {
    return this.request.lastUpdate;
  }

  public getRequestNameText(): string {
    return this.request.requestName;
  }

  public getRequestTypeText(): string {
    if (!this.request._translatedType) {
      if (this.request.workflowId == undefined || this.request.workflowId == null) {
        this.request._translatedType = this.translateService.instant("Type." + this.request.dossierType)
      }
      else {
        this.request._translatedType = this.translateService.instant("WorkFlowRequests.ByWorkflowId." + this.request.workflowId)
      }
    }
    return this.request._translatedType!;
  }

  public getByText(): string {
    if(this.request.previousActor?.toLocaleLowerCase() === "kamer van koophandel" || this.request.previousActor?.toLocaleLowerCase() === "belastingdienst"){
      return this.translateService.instant("dashboard.activitylist.actions." + this.request.previousActor)
    }
    return this.request.previousActor;
  }

  public getRequestPreviousActionText(): string {
    return this.request.previousAction ? this.translateService.instant("dashboard.activitylist.actions." + this.request.previousAction) : "";
  }

  public getRequestStageText(): string {
    if(!this.request.stage){
      return "";
    }
    if (this.request.stage?.toLocaleLowerCase().startsWith("sendgroup")) {
      let sendGroupStringArray = this.request.stage.split(" ");
      if(sendGroupStringArray.length > 1){
        return this.translateService.instant('Request.Send.' + sendGroupStringArray[0], { number: sendGroupStringArray[1] });
      } else {
        return this.translateService.instant('Request.Send._' + sendGroupStringArray[0]);
      }
    }    
    if(this.translateService.instant('dashboard.activitylist.actions.' + this.request.stage) === 'dashboard.activitylist.actions.' + this.request.stage){
      return this.request.stage;
    } else {
      return this.translateService.instant('dashboard.activitylist.actions.' + this.request.stage);
    }

  }

  public getDeadlineDate() {
    return this.request.deadline;
  }

  public getWorkgroupText(): string {
    return this.request.workgroupName!;
  }

  public getOwnerText(): string {
    return this.request.ownerName;
  }

  getProgress() {
    return parseInt(this.request.progress);
  }
}
